import type { AxiosRequestConfigExtended } from '@vision/ui/interfaces';
import type {
  PlannerLabelsArgs,
  PlannerLabelCreateArgs,
  PlannerTaskLabelCreateArgs,
  PlannerTaskLabelDeleteArgs,
} from './task-labels.api.types';
import { createHttpExtraOptions } from '@vision/ui/utils';

export const buildGetLabelsRequest = ({
  accountId,
  plannerId,
  dashboardId,
  name,
}: PlannerLabelsArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/labels${name ? `?name=${name}` : ''}`,
  method: 'GET',
  params: { account_id: accountId, dashboard_id: dashboardId },
});

export const buildCreateLabelRequest = ({
  accountId,
  plannerId,
  dashboardId,
  label,
}: PlannerLabelCreateArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/labels`,
  method: 'POST',
  params: { account_id: accountId, dashboard_id: dashboardId },
  data: label,
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.createLabel.{{status}}',
      autoHandleSuccess: false,
    },
  }),
});

export const buildCreateTaskLabelRequest = ({
  accountId,
  plannerId,
  dashboardId,
  taskId,
  plannerLabelId,
}: PlannerTaskLabelCreateArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/task_labels`,
  method: 'POST',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
  data: { planner_label_id: plannerLabelId },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.createTaskLabel.{{status}}',
      autoHandleSuccess: false,
    },
  }),
});

export const buildDeleteTaskLabelRequest = ({
  accountId,
  plannerId,
  dashboardId,
  taskId,
  taskLabelId,
}: PlannerTaskLabelDeleteArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/task_labels/${taskLabelId}/delete`,
  method: 'POST',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.deleteTaskLabel.{{status}}',
      autoHandleSuccess: false,
    },
  }),
});
